import { render, staticRenderFns } from "./help-card.vue?vue&type=template&id=73db5eb1&scoped=true&"
import script from "./help-card.vue?vue&type=script&lang=js&"
export * from "./help-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73db5eb1",
  null
  
)

export default component.exports